import { useMediaQuery } from "react-responsive";

import { useFeatureFlags } from "@jti/commerce";
import { BREAKPOINT_LARGE } from "@jti/fe-common";

import { OrderItemsSummaryContainer } from "@checkout-v2/features/ItemsSummary/OrderItemsSummaryContainer";
import { OrderPaymentSummaryContainer } from "@checkout-v2/features/PaymentSummary";

export const OrderPageSidebar = () => {
  const isDesktopView = useMediaQuery({ minWidth: BREAKPOINT_LARGE });
  const { ffCheckoutV2EnableIteration2 } = useFeatureFlags();

  return (
    <>
      {isDesktopView && !ffCheckoutV2EnableIteration2 && <OrderItemsSummaryContainer />}
      <OrderPaymentSummaryContainer />
    </>
  );
};
